import React, { useState } from "react";
import { Box, Switch, Typography, styled } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";

const StyledToggleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  background: "linear-gradient(135deg, #9C77FF 0%, #8B5FFF 100%)",
  borderRadius: "50px",
  padding: "8px 20px",
  gap: "16px",
  width: "fit-content",
  boxShadow: "0 8px 32px rgba(156, 119, 255, 0.4)",
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 12px 40px rgba(156, 119, 255, 0.5)",
  },
}));

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 55,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    margin: 2,
    padding: 0,
    transform: "translateX(1px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(29px)",
      "& + .MuiSwitch-track": {
        backgroundColor: "#C4FFCA",
        opacity: 1,
        border: 0,
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#22C55E",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#ffffff",
    width: 22,
    height: 22,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease",
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#C8A9FF",
    borderRadius: 20,
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
  },
}));

const LanguageText = styled(Typography)(({ theme }) => ({
  color: "white",
  fontWeight: 600,
  fontSize: "13px",
  letterSpacing: "0.5px",
  textAlign: "center",
  userSelect: "none",
  transition: "all 0.3s ease",
}));

const LanguageToggle = ({
  isEnglish,
  handleContainerClick,
  handleToggle,
  currentLanguage,
}) => {
  return (
    <StyledToggleContainer onClick={handleContainerClick}>
      <TranslateIcon
        sx={{
          color: "white",
          fontSize: 22,
          opacity: 0.9,
        }}
      />

      <StyledSwitch
        checked={isEnglish}
        onChange={handleToggle}
        onClick={(e) => e.stopPropagation()} // Prevent double toggle
        inputProps={{ "aria-label": "language toggle" }}
      />

      <LanguageText>{isEnglish ? "EN" : `${currentLanguage}`}</LanguageText>
    </StyledToggleContainer>
  );
};

export default LanguageToggle;
